// extracted by mini-css-extract-plugin
module.exports = {"FooterNavigation":"FooterNavigation_FooterNavigation__25ibl","FooterLinks":"FooterNavigation_FooterLinks__uVEDi","FablabTitle":"FooterNavigation_FablabTitle__3M_M7"};